import { applyAssetResolution, buildAssetUrl } from "../../../pixi/assetsInit";

interface ImageProps {
  src: string;
  className?: string;
  classNameBody?: string;
  variant?: "base" | "main";
}

function stripExt(filename: string) {
  const i = filename.lastIndexOf(".");
  return i >= 0 ? filename.slice(0, i) : filename;
}

export const Image = ({
  src,
  variant = "main",
  className,
  classNameBody,
}: ImageProps) => {
  const folder =
    variant === "main" ? "asset_mainOptimized" : "asset_baseOptimized";

  const webpUrl = buildAssetUrl(
    applyAssetResolution(`/${folder}/${stripExt(src)}.webp`)
  );

  return (
    <picture className={classNameBody}>
      <img src={webpUrl} className={className} alt={src} />
    </picture>
  );
};
